import { useState } from "react";
import { toast } from "sonner";
import { Copy, Globe } from "@phosphor-icons/react";

/** Pasteable embed widget snippet generator + admin-side controls. */
export default function EmbedWidgetPanel() {
  const [ref, setRef] = useState("partner-blog");
  const origin = window.location.origin;
  const snippet = `<div id="smarterp-cash-check"></div>
<script src="${origin}/api/public/embed.js?ref=${encodeURIComponent(ref) || "site"}" async defer></script>`;

  const copySnippet = () => {
    navigator.clipboard.writeText(snippet)
      .then(() => toast.success("Snippet copied"))
      .catch(() => {
        toast.error("Clipboard blocked — long-press the snippet to copy manually");
      });
  };

  return (
    <section className="border border-zinc-950 mt-8" data-testid="embed-section">
      <div className="border-b border-zinc-950 bg-zinc-950 text-white px-4 py-2 font-mono text-[11px] tracking-[0.2em] uppercase flex items-center gap-2">
        <Globe size={12} /> embeddable.widget
      </div>
      <div className="p-6">
        <p className="text-sm text-zinc-600 mb-4 max-w-2xl">
          Drop this 2-line snippet into any blog, podcast site, or partner page. It renders a self-contained
          Cash Flow Health Check form — every lead is auto-tagged with the <code className="font-mono text-[11px] bg-zinc-100 px-1">ref</code> tag below so you can attribute leads to each placement.
        </p>

        <div className="mb-4 max-w-md">
          <label className="label-sm text-zinc-500">Attribution tag (visible in the Source column above)</label>
          <input
            value={ref}
            onChange={(e) => setRef(e.target.value)}
            placeholder="partner-blog"
            data-testid="embed-ref-input"
            className="w-full border-b border-zinc-300 focus:border-zinc-950 bg-transparent py-2 text-sm outline-none font-mono"
          />
        </div>

        <div className="border border-zinc-950 bg-zinc-950 text-emerald-300 font-mono text-[12px] p-4 overflow-x-auto" data-testid="embed-snippet">
          <pre className="whitespace-pre-wrap break-all">{snippet}</pre>
        </div>

        <div className="mt-3 flex flex-wrap gap-2">
          <button
            data-testid="embed-copy-btn"
            onClick={copySnippet}
            className="bg-zinc-950 text-white text-xs font-semibold px-4 py-2 hover:bg-[#FF3E00] flex items-center gap-2"
          >
            <Copy size={12} /> COPY SNIPPET
          </button>
          <a
            href={`/cash-health-check?embed-preview=1`}
            target="_blank" rel="noopener noreferrer"
            className="border border-zinc-300 hover:border-zinc-950 text-xs font-semibold px-4 py-2 flex items-center gap-2"
            data-testid="embed-preview-link"
          >
            ↗ PREVIEW FULL PAGE
          </a>
        </div>

        <div className="font-mono text-[10px] text-zinc-400 mt-4">
          Tip: change <code>ref=</code> per placement (e.g. <code>linkedin-jan-post</code>, <code>partner-x</code>) to track which channel converts best.
        </div>
      </div>
    </section>
  );
}
